import { EMPLOYEE_DETAILS_ACTIONS } from 'Actions/index';

const initialState = {
  name: '',
  designation: '',
  requestId: '',
  location: '',
  checkInDate: '',
  checkOutDate: '',
  memberDetails: [],
  timeline: [],
  bookingDetails: {},
  completed: false,
};

const {
  SET_SHORT_STAY_REQUEST_DETAILS,
  SET_SHORT_STAY_TIMELINE,
} = EMPLOYEE_DETAILS_ACTIONS;

const shortStayRequestDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHORT_STAY_REQUEST_DETAILS:
      return {
        ...initialState,
        name: action.payload.name,
        designation: action.payload.designation,
        ...action.payload.shortStay,
      };
    case SET_SHORT_STAY_TIMELINE:
      return {
        ...state,
        timeline: action.payload,
      };
    default:
      return state;
  }
};

export default shortStayRequestDetails;
